/**
 * Key system names for a variety of DRM's
 */
export enum KeySystems {
  WIDEVINE = 'com.widevine.alpha',
  PLAYREADY = 'com.microsoft.playready',
  FAIRPLAY_1_0 = 'com.apple.fps.1_0',
  FAIRPLAY_2_0 = 'com.apple.fps.2_0',
}
